// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2ceUz","inner":"Footer_inner__1p06w"};